import React, { useState, useEffect } from 'react';
import { connect, RootStateOrAny, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import '../../../styles/components/options/popups/deleteUser.scss';
import * as AuthActions from '../../../actions/Auth.actions';
import closeBtn from '../../../assets/popup_close.svg';
import ssoFacebook from '../../../assets/sso_facebook.svg';
import ssoGoogle from '../../../assets/sso_google.svg';
import ssoLinkedin from '../../../assets/sso_linkedin.svg';
import ssoTwiter from '../../../assets/sso_twitter.svg';
import { signIn, deleteUserFromApp } from '../../../auth/Auth';
import { signInWithSSO } from '../../../auth/Auth';
import { DELETE_USER_FORM } from '../../../constants/FormNames';
import { AuthTypes } from '../../../constants/Types';
import Button from '../../Button';
import ImageButton from '../../ImageButton';
import TextInput from '../../TextInput';

const DeleteUser = ({ setDeletePopup, auth, user, deleteUser }) => {
	const [isSSO, setIsSSO] = useState(false);
	const [isSSOLoggedIn, setIsSSOLoggedIn] = useState(false);
	const [ssoIcon, setSsoIcon] = useState({
		icon: ssoGoogle,
		text: 'Google',
		action: () => {
			null;
		},
	});
	const [loginError, setloginError] = useState('');
	const navigate = useHistory();
	const form = useSelector(
		(state: RootStateOrAny) => state?.forms?.[DELETE_USER_FORM]?.values
	);
	const [submitting, setSubmitting] = useState(false);

	const handleDeletion = () => {
		setSubmitting(true);
		if (isSSO) {
			deleteUser(
				auth.id,
				() => {
					deleteUserFromApp(
						() => {
							navigate.push('/login');
						},
						() => {
							console.log('failed');
						}
					);
				},
				() => {
					console.log('failed');
				}
			);
		} else {
			signIn(
				user.userName,
				form?.password,
				() => {
					deleteUser(
						auth.id,
						() => {
							deleteUserFromApp(
								() => {
									setSubmitting(false);
									navigate.push('/login');
								},
								() => {
									console.log('delete failed');
								}
							);
						},
						() => {
							console.log('delete failed');
						}
					);
				},
				err => {
					setSubmitting(false);
					console.log(err);
					setloginError('Incorrect password' || '');
				}
			);
		}
	};

	const onPressFacebookSignIn = () =>
		signInWithSSO(
			AuthTypes.FACEBOOK,
			() => setIsSSOLoggedIn(true),
			() => console.log('login failed')
		);
	const onPressGoogleSignIn = () =>
		signInWithSSO(
			AuthTypes.GOOGLE,
			() => setIsSSOLoggedIn(true),
			() => console.log('login failed')
		);
	const onPressTwitterSignIn = () =>
		signInWithSSO(
			AuthTypes.TWITTER,
			() => setIsSSOLoggedIn(true),
			() => console.log('login failed')
		);
	const onPressLinkedIn = () =>
		signInWithSSO(
			AuthTypes.LINKEDIN,
			() => setIsSSOLoggedIn(true),
			() => console.log('login failed')
		);

	useEffect(() => {
		switch (auth.authType) {
			case AuthTypes.EMAIL:
				setIsSSO(false);
				break;
			case AuthTypes.GOOGLE:
				setIsSSO(true);
				setSsoIcon({
					icon: ssoGoogle,
					text: 'Google',
					action: onPressGoogleSignIn,
				});
				break;
			case AuthTypes.FACEBOOK:
				setIsSSO(true);
				setSsoIcon({
					icon: ssoFacebook,
					text: 'Facebook',
					action: onPressFacebookSignIn,
				});
				break;
			case AuthTypes.TWITTER:
				setIsSSO(true);
				setSsoIcon({
					icon: ssoTwiter,
					text: 'Twitter',
					action: onPressTwitterSignIn,
				});
				break;
			case AuthTypes.LINKEDIN:
				setIsSSO(true);
				setSsoIcon({
					icon: ssoLinkedin,
					text: 'Linkedin',
					action: onPressLinkedIn,
				});
				break;
			default:
			// code block
		}
	}, []);

	return (
		<div className='delete-user-popup-wrapper'>
			<div className='delete-popup'>
				<div className='top-section'>
					<div className='title'>Delete your account</div>
					<div className='close-button-container'>
						<button className='close-button' onClick={() => setDeletePopup(false)}>
							<img src={closeBtn} alt='' />
						</button>
					</div>
				</div>
				<div className='middle-section'>
					<div className='caption'>
						Are you sure you want to delete your account?
					</div>
					<div className='description'>
						You need to log into your account one last time to delete the account?
					</div>
				</div>
				<div className='bottom-section'>
					{!isSSO && (
						<TextInput
							form={DELETE_USER_FORM}
							name={'password'}
							validations={null}
							id={'password'}
							placeholder='Enter your password'
							type='password'
							errorText={loginError}
						/>
					)}
					{isSSO && (
						<ImageButton
							image={ssoIcon?.icon || undefined}
							onClickHandler={ssoIcon.action}
							className='sso-login'
							disabled={isSSOLoggedIn}
							text={`Sign in with ${ssoIcon?.text}`}
						/>
					)}
					<Button
						labal='Confirm and Delete'
						diactivated={
							isSSO
								? !isSSOLoggedIn
									? true
									: false
								: form?.password.trim() === ''
								? true
								: false
						}
						onClickEvent={handleDeletion}
						clicked={true}
						loading={submitting}
					/>
				</div>
			</div>
		</div>
	);
};

const mapStateToProps = ({ auth, user }) => ({
	auth,
	user,
});

const mapDispatchToProps = {
	deleteUser: AuthActions.deleteUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteUser);
